import useSEO from "../lib/useSEO";

export default function Imprint() {
  useSEO({
    title: "Impressum | Tæste GbR — Catering & Streetfood",
    description: "Impressum der Tæste GbR – Catering & Streetfood, 02999 Lohsa. Angaben gemäß § 5 DDG.",
    path: "/impressum",
  });
  return (
    <div data-testid="imprint-page" className="max-w-3xl mx-auto px-6 lg:px-12 py-20 md:py-28">
      <p className="eyebrow">Rechtliches</p>
      <h1 className="font-display text-5xl md:text-6xl mt-3 leading-[1.05]">Impressum</h1>

      <div className="mt-10 space-y-10 text-[hsl(var(--foreground))] leading-relaxed">
        <section>
          <p className="text-sm uppercase tracking-widest text-[hsl(var(--muted-foreground))] mb-2">
            Angaben gemäß § 5 DDG
          </p>
          <p className="font-display text-2xl">Tæste GbR – Catering & Streetfood</p>
          <p className="mt-3 text-[hsl(var(--muted-foreground))]">
            Vertreten durch die Gesellschafter:
          </p>
          <p className="mt-1">Edgar Robel</p>
          <p>Annabell Möller</p>
          <p className="mt-4">
            Alte Bahnhofstraße 1a<br />
            02999 Lohsa<br />
            Deutschland
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl">Kontakt</h2>
          <p className="mt-3">
            Telefon:{" "}
            <a href="tel:+4915129402613" className="underline hover:text-[hsl(var(--primary))]">
              +49 1512 9402613
            </a>
          </p>
          <p>
            E-Mail:{" "}
            <a href="mailto:info@taeste.de" className="underline hover:text-[hsl(var(--primary))]">
              info@taeste.de
            </a>
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
          <p className="mt-3">Edgar Robel</p>
          <p>Alte Bahnhofstraße 1a</p>
          <p>02999 Lohsa</p>
          <p>Deutschland</p>
        </section>

        <section>
          <h2 className="font-display text-2xl">Hinweis zur Online-Streitbeilegung</h2>
          <p className="mt-3 text-[hsl(var(--muted-foreground))]">
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
            <a
              href="https://ec.europa.eu/consumers/odr/"
              target="_blank"
              rel="noreferrer"
              className="underline hover:text-[hsl(var(--primary))]"
            >
              https://ec.europa.eu/consumers/odr/
            </a>
          </p>
          <p className="mt-3 text-[hsl(var(--muted-foreground))]">
            Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>
      </div>
    </div>
  );
}
